import { render, staticRenderFns } from "./VWord.vue?vue&type=template&id=154dfad0&"
import script from "./VWord.vue?vue&type=script&lang=ts&"
export * from "./VWord.vue?vue&type=script&lang=ts&"
import style0 from "./VWord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports